import styled from "styled-components"

export const BaseSectionWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 24px;
	border-bottom: 1px solid #eaeafd;
	padding-bottom: 24px;
	.firstSection {
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		gap: 16px;
		.banner {
			padding: 12px;
			color: #5b3fff;
			background-color: #f2f0ff;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			border-radius: 8px;
			span {
				color: #000;
			}
		}
	}
	.lastSection {
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		gap: 16px;
		.containerGuestLogin {
			.buttonGuestLogin {
				border: 1px solid #eaeef4;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px;
				border-radius: 8px;
				div {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					&:first-child {
						width: calc(100% - 20px);
						font-weight: 500;
						font-size: 14px;
						text-align: center;
						color: #261b6a;
					}
					&:last-child {
						color: #261b6a;
						width: 20px;
					}
				}
			}
		}
	}
`
